import type {
  IEffectProps,
  EffectName,
  ConcreteEffect,
  IEffectEvaluatedProps,
} from "./types";

import { FadeIn, RevealDown, ZoomIn, SlideDown, SlideUp } from "./animations";
import { useMemo } from "react";

const EffectMap: Record<EffectName, ConcreteEffect> = {
  "fade-in": FadeIn,
  "zoom-in": ZoomIn,
  "slide-up": SlideUp,
  "slide-down": SlideDown,
  "reveal-down": RevealDown,
};

export function Effect(props: IEffectProps) {
  const { effect, children } = props;

  const concreteProps = useMemo<IEffectEvaluatedProps>(() => {
    const value = typeof effect === "string" ? { effect } : effect;

    return {
      ...props,
      ...(value ?? {}),
      active: props.active !== false,
      effect:
        typeof effect === "string"
          ? effect
          : (effect?.effect as undefined | EffectName),
    };
  }, [effect, props]);

  const Component = useMemo(() => {
    if (!concreteProps.effect) {
      return null;
    }

    return EffectMap[concreteProps.effect];
  }, [concreteProps]);

  if (!Component) {
    return children;
  }

  return <Component {...concreteProps}>{children}</Component>;
}
